import React from 'react';
import SideMenu from '../Components/Layout/SideMenu';
import TopBar from '../Components/Layout/TopBar';
import PageHeader from '../Components/Common/PageHeader';
import PaymentsPageTable from '../Components/Common/PaymentsPageTable';
 const Payments = () => {
    return ( <main>
        <SideMenu/>

        <div className='DashMain'>
            <TopBar PageTitle="Payments"/>

            <div className='DashContent'>
                <PageHeader HeaderTitle="Payments" HeaderSub="Track all payment transactions" PageHeaderStyle="PageHeaderNB"/>

                <PaymentsPageTable />
            </div>
        </div>
    </main> );
 }
  
 export default Payments;